import { render, staticRenderFns } from "./AllCallendarTypes.vue?vue&type=template&id=64c30dfc&scoped=true&"
import script from "./AllCallendarTypes.vue?vue&type=script&lang=js&"
export * from "./AllCallendarTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c30dfc",
  null
  
)

export default component.exports